module.exports = __webpack_public_path__ + "static/media/oman-beverly-smyth.092fb59e.png";